import React from 'react';
import { ICON_SEARCH, ICON_NEW, ICON_CHECKOUT, ICON_LIST } from './extras/icons';
import MainContent from './layout/MainContent';
import Dashboard from './home/Dashboard';

const Home = () => {
    const nodes = [
        {
            name: 'Dashboard',
            link: '/'
        },{
            name: 'Inicio'
        }
    ];
    const actions  = []
    //Renderizo
    return (
        <MainContent 
            title='Escritorio' 
            subtitle='Inicio' 
            nodes={nodes}
            actions={actions}
            component={Dashboard} />
    );
};

export default Home;